import {
  FileProtectOutlined,
  FileSyncOutlined,
  MessageOutlined,
  ProfileOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { RECRUIT } from "@/shared/modules/constants/modules-id";
import { AccessTokens, EnabledTokens } from "gql/graphql";
import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import { VACANCIES_LIST_PATH } from "@/modules/recruiting/pages/vacancies-list";
import { CANDIDATES_LIST_PAGE } from "@/modules/recruiting/pages/candidates-list";
import { MY_VACANCIES_LIST_PATH } from "@/modules/recruiting/pages/my-vacancies-list";
import { INTERVIEWS_PATH } from "@/modules/recruiting/pages/interviews";
import { JOB_OFFERS_PATH } from "@/modules/recruiting/pages/job-offers";

export const recruitingMenu: NavigationItem = {
  label: "recruitment",
  icon: <UsergroupAddOutlined />,
  requiredModule: RECRUIT,
  children: [
    {
      label: "vacancies",
      icon: <ProfileOutlined />,
      to: VACANCIES_LIST_PATH,
      requiredAtLeastOnePermission: [EnabledTokens.RecruitingVacancies],
    },
    {
      label: "candidates",
      icon: <UsergroupAddOutlined />,
      to: CANDIDATES_LIST_PAGE,
      requiredAtLeastOnePermission: [EnabledTokens.RecruitingCandidates],
    },
    {
      label: "my vacancies",
      icon: <FileSyncOutlined />,
      to: MY_VACANCIES_LIST_PATH,
      // CLOUD-644: «Вакансии» и «Мои вакансии» схлопнулись в одно право с контекстами,
      // и снимок различить их не умеет — пункты появляются и исчезают вместе, пока
      // бэкенд не заведёт вычисляемое право «чужие вакансии».
      requiredAtLeastOnePermission: [EnabledTokens.RecruitingVacancies],
    },
    {
      label: "interviews",
      icon: <MessageOutlined />,
      to: INTERVIEWS_PATH,
      requiredAtLeastOnePermission: [EnabledTokens.RecruitingInterviews],
    },
    {
      label: "job offers",
      icon: <FileProtectOutlined />,
      to: JOB_OFFERS_PATH,
      requiredAtLeastOnePermission: [AccessTokens.RecruitingJobOffers],
    },
  ],
};
